import {
  Flex,
  Heading,
  IconButton,
  Tooltip,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { useContext } from "react";
import Loader from "../../../utils/Loader/Loader";
import Table from "../../Tables/Table";
import { AgencyContext } from "../AgencyProvider/AgencyProvider";
import WebhookModal from "./WebhookModal";
import useWebhooks from "./useWebhooks";
import { AddIcon } from "@chakra-ui/icons";
export default function Webhooks() {
  const { fetchWebhooks, webhookTable, status } = useWebhooks();
  const {
    isOpen,
    onOpen: openWebhookModal,
    onClose: closeWebhookModal,
  } = useDisclosure();
  const loading = status === "loading";
  const agency = useContext(AgencyContext);
  const { textColor, buttonColorScheme } = agency;
  return (
    <>
      <Flex direction={"column"} gap={3} w={"100%"} h={"100%"}>
        <Flex gap={2} w={"100%"} alignItems="center" p={2}>
          <Heading color={textColor} fontSize="xl">
            Webhook
          </Heading>
          <Tooltip label="Add Webhook">
            <IconButton
              colorScheme={buttonColorScheme}
              onClick={() => openWebhookModal()}
              icon={<AddIcon />}
              size={"xs"}
            />
          </Tooltip>
        </Flex>

        {loading ? (
          <Loader />
        ) : (
          <Table
            columns={webhookTable.heads}
            table={"webhooks"}
            fetch={fetchWebhooks}
            data={webhookTable.tableData}
          />
        )}
      </Flex>

      <WebhookModal
        isOpen={isOpen}
        fetchWebhooks={fetchWebhooks}
        onClose={closeWebhookModal}
      />
    </>
  );
}
